<script setup>

const props = defineProps({
    client: Object
});
</script>

<template>
    <div class="invitation__data_client">    
        <div class="invitation__client_wrapper">
            <div class="form_wrapper d-flex">
                <div class="form_description">
                    <span class="invitation-name">
                        {{ client.firstname }} {{ client.lastname }} {{ client.second_lastname }}
                    </span>
                </div>
            </div>
            <div class="form_wrapper d-flex">
                <div class="form_description">
                    <span class="invitation__description_input">
                        {{ client.email }}
                    </span>
                </div>
            </div>
            <div class="form_wrapper d-flex" v-if="client.mobile && client.mobile.length > 0">
                <div class="form_description">
                    <span class="invitation__description_input">
                        {{ client.mobile }}
                    </span>
                </div>
            </div>
            <div class="form_wrapper d-flex">
                <div class="nif-title">
                    {{ $t("user.vat_number") }}:
                </div>
                <div class="form_description">
                    <span class="invitation__description_input">
                        {{ client.vat_number }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>


.form_wrapper {
    display: flex;
    
}

.form_wrapper > *:nth-child(even) {
    flex: 4;
}

.nif-title{
    margin-right: 0.5rem;

    @media (min-width: 1023px) and (max-width: 1024px) and (orientation: landscape) {
        margin-right: 0.5rem;
    }

    @media (min-width: 1025px) and (max-width: 1200px) and (orientation: landscape) {
        margin-right: 0.5rem;
    }

    @media (min-width: 1201px) and (max-width: 1400px) and (orientation: landscape) {
        margin-right: 0.5rem;
    }

    
}
.invitation-name{
    font-family: "CircularStd-Bold";
    font-size: 20px;
    color: #153440;
    opacity: 1;
    
}

@media (max-width: 576px) {
    .form_wrapper .d-flex{
    display: block !important;
    gap: 1em;
    padding-bottom: 5px;
    margin-bottom: 10rem;
}
}

@media (min-width: 1024px) and (max-width: 1400px) and (orientation: landscape) {
      

    .form_wrapper .d-flex{
        
        gap: 0;
        
    }
}
</style>